import React from 'react';
import { Text } from 'react-native';
import { buildHighlightedTextSegments } from '../utils/searchUtils';

export function HighlightedSearchText({
  text,
  query,
  style,
  highlightStyle,
  numberOfLines,
}) {
  const boldStyle = highlightStyle || { fontWeight: '700' };
  const segments = buildHighlightedTextSegments(text, query);

  return (
    <Text style={style} numberOfLines={numberOfLines}>
      {segments.map((segment, index) => (
        <Text key={index} style={segment.highlighted ? [style, boldStyle] : style}>
          {segment.text}
        </Text>
      ))}
    </Text>
  );
}

export function HighlightedSearchTextParts({
  parts,
  query,
  style,
  separator = ' · ',
  highlightStyle,
  numberOfLines,
}) {
  if (!parts?.length) return null;

  const boldStyle = highlightStyle || { fontWeight: '700' };

  if (!query?.trim()) {
    return (
      <Text style={style} numberOfLines={numberOfLines}>
        {parts.join(separator)}
      </Text>
    );
  }

  return (
    <Text style={style} numberOfLines={numberOfLines}>
      {parts.map((part, partIndex) => {
        const segments = buildHighlightedTextSegments(part, query);
        return (
          <React.Fragment key={partIndex}>
            {partIndex > 0 ? separator : null}
            {segments.map((segment, segIndex) => (
              <Text
                key={segIndex}
                style={segment.highlighted ? [style, boldStyle] : style}
              >
                {segment.text}
              </Text>
            ))}
          </React.Fragment>
        );
      })}
    </Text>
  );
}
